"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function ElektriciteitskeuringAanvragen() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section ref={ref} className="relative min-h-[600px] flex items-center justify-center overflow-hidden bg-dark-background">
      {}
      <div className="absolute inset-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1511866/img/electrical_panel_inspection_background.png)]" style={{
      transform: isVisible ? "scale(1.05)" : "scale(1)",
      transition: "transform 2s ease-out"
    }}>
        <div className="absolute inset-0 bg-dark-background/60 backdrop-blur-sm" />
      </div>

      {}
      <div className="relative z-10 max-w-3xl mx-auto px-6 py-24 text-center">
        {}
        <h1 className={`text-5xl md:text-6xl font-bold text-foreground-dark mb-6 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          Elektriciteitskeuring aanvragen
        </h1>

        {}
        <p className={`text-xl md:text-2xl text-foreground-dark/90 mb-8 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
        transitionDelay: isVisible ? "150ms" : "0ms"
      }}>
          Veilig en conform: laat uw elektrische installatie controleren door gecertificeerde experts
        </p>

        {}
        <div className={`mb-4 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
        transitionDelay: isVisible ? "300ms" : "0ms"
      }}>
          <Link to="/ElectricalInspectionPage">
            <Button size="lg" className="px-8 py-6 text-lg font-semibold rounded-md bg-primary text-foreground-primary shadow-medium hover:shadow-strong hover:scale-[1.04] transition-all duration-[120ms] ease-in-out">
              Nu aanvragen
            </Button>
          </Link>
        </div>

        {}
        <p className={`text-sm text-foreground-dark/70 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
        transitionDelay: isVisible ? "450ms" : "0ms"
      }}>
          Binnen 48 uur een afspraak of vraag eerst een vrijblijvende offerte aan
        </p>
      </div>
    </section>;
}